// 隐私协议
let sdkList = {
  title: '第三方 SDK类服务商目录',
  content: [
    {
      text: '腾讯Bugly SDK',
      subText: [
        { text: '使用目的：用于监测APP稳定性并进行故障诊断、崩溃上报、以快速解决异常情况'},
        { text: '数据类型：设备信息'},
        { text: `官网链接：<a class="link" target="_blank" href="https://bugly.qq.com/v2/">https://bugly.qq.com/v2/</a>`},
      ]
    },
    {
      text: '小米推送 SDK',
      subText: [
        { text: '使用目的：推送相关新闻资讯及消息'},
        { text: '数据类型：设备信息以及在您开启位置权限的情况下收集您的位置信息'},
        { text: `官网链接：<a class="link" target="_blank" href="https://dev.mi.com/console/appservice/push.html">https://dev.mi.com/console/appservice/push.html</a>`},
      ]
    },
    {
      text: '华为推送 SDK',
      subText: [
        { text: '使用目的：推送相关新闻资讯及消息'},
        { text: '数据类型：设备信息以及在您开启位置权限的情况下收集您的位置信息'},
        { text: `官网链接：<a class="link" target="_blank" href="https://developer.huawei.com/consumer/cn/service/hms/pushservice.html">https://developer.huawei.com/consumer/cn/service/hms/pushservice.html</a>`},
      ]
    },
    {
      text: 'VIVO推送 SDK',
      subText: [
        { text: '使用目的：推送相关新闻资讯及消息'},
        { text: '数据类型：设备信息以及在您开启位置权限的情况下收集您的位置信息'},
        { text: `官网链接：<a class="link" target="_blank" href="https://dev.vivo.com.cn/documentcenter/doc/233">https://dev.vivo.com.cn/documentcenter/doc/233</a>`},
      ]
    },
    {
      text: 'OPPO推送 SDK',
      subText: [
        { text: '使用目的：推送相关新闻资讯及消息'},
        { text: '数据类型：设备信息以及在您开启位置权限的情况下收集您的位置信息'},
        { text: `官网链接：<a class="link" target="_blank" href="https://open.oppomobile.com/wiki/doctid=10196">https://open.oppomobile.com/wiki/doctid=10196</a>`},
      ]
    },
    {
      text: '魅族推送 SDK',
      subText: [
        { text: '使用目的：推送相关新闻资讯及消息'},
        { text: '数据类型：设备信息以及在您开启位置权限的情况下收集您的位置信息'},
        { text: `官网链接：<a class="link" target="_blank" href="https://open.flyme.cn/open-web/views/push.html">https://open.flyme.cn/open-web/views/push.html</a>`},
      ]
    },
    {
      text: '微信 SDK',
      subText: [
        { text: '使用目的：便于您使用第三方账号进行登录以及分享内容到第三方平台'},
        { text: '数据类型：设备信息'},
        { text: `官网链接：<a class="link" target="_blank" href="https://open.weixin.qq.com/">https://open.weixin.qq.com/</a>`},
      ]
    },
    {
      text: '微信支付 SDK',
      subText: [
        { text: '使用目的：帮助用户在应用内使用微信支付'},
        { text: '数据类型：设备信息'},
        { text: `官网链接：<a class="link" target="_blank" href="https://pay.weixin.qq.com/">https://pay.weixin.qq.com/</a>`},
      ]
    },
    {
      text: '支付宝 SDK',
      subText: [
        { text: '使用目的：帮助用户在应用内使用支付宝支付'},
        { text: '数据类型：设备信息'},
        { text: `官网链接：<a class="link" target="_blank" href="https://docs.open.alipay.com/">https://docs.open.alipay.com/</a>`},
      ]
    },
    {
      text: '高德定位 SDK',
      subText: [
        { text: '使用目的：确认您所在的位置信息，以便及时给您提供当地新闻'},
        { text: '数据类型：设备信息以及在您开启位置权限的情况下收集您的位置信息'},
        { text: `官网链接：<a class="link" target="_blank" href="https://lbs.amap.com/">https://lbs.amap.com/</a>`},
      ]
    },
    {
      text: '网易云信 SDK',
      subText: [
        { text: '使用目的：帮助用户之间的聊天通讯'},
        { text: '数据类型：设备信息'},
        { text: `官网链接：<a class="link" target="_blank" href="https://yunxin.163.com/">https://yunxin.163.com/</a>`},
      ]
    },


  ]
}
export default sdkList
